import {procFileProcWithPercent} from "../../../Common/util/ProcService";
import {useState} from "react";
import {AxiosProgressEvent} from "axios/index";

export type DownloadwithPercentOptions = {
    docId:string;
    docVersion:number;
    defFileName?: string;
    fileSize:number;
};

const useDownloadFilewithPercent = ( ) => {

    const [calcfileSize, setCalcFileSize] = useState<number>(0);
    const [downloadUrl, setDownloadUrl] = useState<string | null>(null);
    const [downloadStatus, setDownloadStatus] = useState<'idle' | 'downloading' | 'completed'>('idle');
    const [percent, setPercent] = useState<number>(0);

    function getProccessPercent(progressEvent:AxiosProgressEvent)
    {
            if (progressEvent ) {
                const total =  progressEvent.total ?? calcfileSize;
                const percentComplete = Math.floor((progressEvent.loaded*100) / total);
                console.log(percentComplete + "%");

                if (percentComplete > 100)
                {
                    setPercent(100);
                }
                else {
                    setPercent(percentComplete);
                }



            }
    }

    const downloadFile = async (downloadwithPercentOptions: DownloadwithPercentOptions) => {
        try {
            const { docId, docVersion, defFileName, fileSize} = downloadwithPercentOptions;
            setCalcFileSize(fileSize);
            setPercent(0);
            setDownloadStatus('downloading');

            const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;
            const axiosResponse = await procFileProcWithPercent<any>("get", `${serviceCode}DCS03`, {docId : docId, docVersion:docVersion}, getProccessPercent)
            const blobFile = new Blob([axiosResponse.data]);
            const objectUrl = window.URL.createObjectURL(blobFile);
            setDownloadUrl(objectUrl);
            setDownloadStatus('completed');
            setPercent(100);

            // a태그 Element를 생성해준다.
            const aElement = document.createElement('a');
            aElement.href = objectUrl;
            // 파일명 설정
            aElement.download = defFileName as string;

            // document body 위에 생성한 a태그를 부착 시킨다.
            document.body.appendChild(aElement);

            // 부착 시킨 a태그를 Click!(이벤트 발생 시키기) 그러면 다운로드가 된다.
            aElement.click();
            setTimeout(() => {
                // 이제 더이상 필요 없으니 생성한 a태그를 1초후 삭제 시켜준다.
                aElement.remove();
            }, 1000);

        } catch (error) {
            console.error('Error downloading file:', error);
            setDownloadStatus('idle');
        }
    };

    const downloadFileAdmin = async (fileId:string, fileName:string, fileSize:number) => {
        try {
            setCalcFileSize(fileSize);
            setPercent(0);
            setDownloadStatus('downloading');

            const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;
            const axiosResponse = await procFileProcWithPercent<any>("get", `${serviceCode}ADS27`, {fileId : fileId}, getProccessPercent)
            const blobFile = new Blob([axiosResponse.data]);
            const objectUrl = window.URL.createObjectURL(blobFile);
            setDownloadUrl(objectUrl);
            setDownloadStatus('completed');
            setPercent(100);

            // a태그 Element를 생성해준다.
            const aElement = document.createElement('a');
            aElement.href = objectUrl;
            // 파일명 설정
            aElement.download = fileName as string;

            // document body 위에 생성한 a태그를 부착 시킨다.
            document.body.appendChild(aElement);

            // 부착 시킨 a태그를 Click!(이벤트 발생 시키기) 그러면 다운로드가 된다.
            aElement.click();
            setTimeout(() => {
                // 이제 더이상 필요 없으니 생성한 a태그를 1초후 삭제 시켜준다.
                aElement.remove();
            }, 1000);

        } catch (error) {
            console.error('Error downloading file:', error);
            setDownloadStatus('idle');
        }
    };

    /*
    useEffect(() => {
        downloadFile();
        return () => {
            if (downloadUrl) {
                window.URL.revokeObjectURL(downloadUrl);
            }
        };
    }, [downloadwithPercentOptions]);
*/
    return { downloadStatus, percent , downloadFile, downloadFileAdmin};
};

export default useDownloadFilewithPercent;